"use client";
import { jsx } from "react/jsx-runtime";
import { Text } from "@nxt-costco-com/forge-components";
import { RichTextEntryClient } from "../../../../../../Media/RichTextEntry/RichTextEntryClient.js";
import "./AdButlerPriceText.css";
import { getFormattedPrice } from "./lib.js";
const COMPONENT_NAME = "Price";
const Price = (props) => {
  const { priceText, priceValue, adButlerPriceText, locale, uniqueId } = props || {};
  if (!priceValue && !adButlerPriceText) return null;
  if (adButlerPriceText) {
    return /* @__PURE__ */ jsx(
      Text,
      {
        bold: true,
        uniqueId: `${COMPONENT_NAME}_${uniqueId}`,
        variant: "t5",
        children: /* @__PURE__ */ jsx(
          RichTextEntryClient,
          {
            entryId: `${COMPONENT_NAME}_${uniqueId}`,
            rich_text_editor: adButlerPriceText
          }
        )
      }
    );
  }
  let formattedPrice;
  if (Array.isArray(priceValue) && priceValue.length === 2) {
    formattedPrice = priceValue.map(
      (price) => getFormattedPrice(locale, price)
    );
    formattedPrice = formattedPrice.join(" - ");
  } else {
    formattedPrice = priceText ? `${priceText} ${getFormattedPrice(locale, priceValue)}` : getFormattedPrice(locale, priceValue);
  }
  return /* @__PURE__ */ jsx(
    Text,
    {
      bold: true,
      uniqueId: `${COMPONENT_NAME}_${uniqueId}`,
      variant: "t5",
      children: adButlerPriceText || formattedPrice
    }
  );
};
Price.displayName = COMPONENT_NAME;
export {
  Price
};
